import React, { useEffect } from "react";
import SubVisual from "../../components/SubVisual";
import * as S from "./styled";
import subVisualEducation from "../../assets/subVisual/subVisualEducation.png";
import EducationSlide from "../../components/Home/EducationSlide";
import Aos from "aos";
import { Helmet } from "react-helmet-async";

const Education = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://ipdiakorea.com" />
        <meta
          property="og:image"
          content="http://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.EducationContainer>
        <SubVisual
          src={subVisualEducation}
          title="교육 안내"
          subTitle="자격 검정 안내"
        />
        <S.EducationWrapper>
          <div className="inner">
            <S.EducationWrap>
              <div
                className="title-wrap"
                data-aos="fade"
                data-aos-duration={800}
                data-aos-easing="linear"
              >
                <h6>IPDIA KOREA 국제실용댄스 지도자협회는</h6>
                <p>
                  현직 댄스업계의 커리어와 노하우를 가진 전문가들로 구성되어
                  있으며, <br className="pc-br" />
                  체계적이고 실무 중심인 교육시스템을 통해 전문인재 양성 및
                  실력향상을 위한 명확한 비전을 제시합니다.
                  <br />
                  <br />
                  특히, 현장에서 필요로 하는 실질적인 기술과 지식을 습득할 수
                  있도록 설계되어 있습니다.
                </p>
              </div>
              <div className="goals-wrap">
                <p>교육 핵심 목표</p>
                <ul>
                  <li
                    data-aos="fade-up"
                    data-aos-duration={600}
                    data-aos-delay={200}
                    data-aos-easing="linear"
                  >
                    전문 댄스
                    <br />
                    지도자로서의 성장
                  </li>
                  <li
                    data-aos="fade-up"
                    data-aos-duration={600}
                    data-aos-delay={400}
                    data-aos-easing="linear"
                  >
                    프로 레벨까지의
                    <br />
                    실력 향상
                  </li>
                  <li
                    data-aos="fade-up"
                    data-aos-duration={600}
                    data-aos-delay={600}
                    data-aos-easing="linear"
                  >
                    수료자 전문세미나
                    <br />
                    시스템으로 지속성장 케어
                  </li>
                </ul>
              </div>
              <p
                data-aos="fade-up"
                data-aos-duration={600}
                data-aos-delay={800}
                data-aos-easing="linear"
              >
                수료 후, IPDIA KOREA 전문 자격증 과정을 이수한 수료자에게만
                프로세미나 참여 자격이 부여되며,
                <br />
                이를 통해 지속적인 교류와 성장을 지원하는 체계적인 시스템이
                구축되어 있습니다.
              </p>
              <EducationSlide />
            </S.EducationWrap>
          </div>
        </S.EducationWrapper>
      </S.EducationContainer>
    </>
  );
};

export default Education;
